import React, { FunctionComponent } from 'react';

import { CSSObject } from '@emotion/core';
import Decoration from '@gojob/ui-bits/Cta/CheeryContainer/Decoration';
import Icon from '@gojob/ui-bits/Icon';
import usePalette from '@gojob/ui-bits/styles/PaletteProvider/usePalette';
import useTheme from '@gojob/ui-bits/styles/useTheme';
import Text, { TextProps } from '@gojob/ui-bits/Text';
import { titleLevel } from '../../types/title';

export interface CheeryTitleProps extends TextProps<titleLevel> {
  cherrySize?: number;
  iconClassname?: CSSObject;
}

const useStyles = () => {
  const { spacing, colors } = useTheme();
  const {
    button: { accent },
  } = usePalette();

  return {
    container: {
      position: 'relative',
    },
    cheery: {
      color: colors[accent],
      position: 'absolute',
      top: spacing(-1),
      left: spacing(-0.5),
      transform: 'translate(-50%, -50%) rotate(20deg)',
    },
  } as const;
};

const CheeryTitle: FunctionComponent<CheeryTitleProps> = (props) => {
  const { children, cherrySize = 5, iconClassname, ...other } = props;
  const classes = useStyles();

  return (
    <Text {...other}>
      {/** Bind the icon and content within the span */}
      <span css={classes.container}>
        <Icon as={Decoration as any} css={[classes.cheery, iconClassname]} size={cherrySize} />
        {children}
      </span>
    </Text>
  );
};

export default CheeryTitle;
